module.exports = __webpack_public_path__ + "img/dashboard-icon.22650445.svg";